import { InfoList } from '@orobix/orobix-fe-components'
import { FormikErrors } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import ObservationsSelectField from '../../components/ObservationsSelectField/ObservationsSelectField'
import { useStore } from '../../store/store'
import { getClassesSummary } from '../../utils/forms'
import DatasetImageNewForm, {
  DatasetImageNewFormValues,
} from './DatasetImageNewForm'

export type DatasetImageFormValues = DatasetImageNewFormValues

interface RouteParams {
  projectId: string
  productId: string
}

const requiredImages = 1

interface DatasetImageTrainingProps {
  onObservationsCreated?: (toAdd: number) => void
}
const DatasetImageTraining = ({
  onObservationsCreated,
}: DatasetImageTrainingProps) => {
  const { t } = useTranslation()
  const { product } = useStore()
  const { productId, projectId } = useParams<RouteParams>()
  const [showDatasetManager, setShowDatasetManager] = useState(false)
  const [selectedDatasets, setSelectedDatasets] = useState<string[]>([])

  return product ? (
    <DatasetImageNewForm<DatasetImageFormValues>
      productType={product.type}
      productId={productId}
      projectId={projectId}
      requiredImages={requiredImages}
      initialValues={{
        selectedObservations: [],
        name: '',
        dataset: { value: '', label: '' },
      }}
      renderRightColumn={({ values }) => (
        <InfoList
          list={[
            ...getClassesSummary(values.selectedObservations, t).map((i) => ({
              title: i.title,
              value: i.count,
            })),
            {
              title: t('Total images'),
              value: values.selectedObservations.length,
            },
          ]}
        />
      )}
      validate={(values) => {
        const errors: FormikErrors<{ [field: string]: string }> = {}

        if (values.selectedObservations.length < requiredImages) {
          errors.selectedObservations = t(
            'You need to use at least {{ count }} image',
            { count: requiredImages }
          )
        }

        if (!values.name && !values.dataset) {
          errors.name = t('This field is required')
        }

        return errors
      }}
      showDatasetManager={showDatasetManager}
      setSelectedDatasets={setSelectedDatasets}
    >
      <ObservationsSelectField
        name="selectedObservations"
        productType={product.type}
        productId={Number(productId)}
        showDatasetManager
        setShowDatasetManager={setShowDatasetManager}
        dataset={selectedDatasets.length > 0 ? selectedDatasets : undefined}
        onObservationsCreated={onObservationsCreated}
        inTraining={false}
      />
    </DatasetImageNewForm>
  ) : null
}

export default DatasetImageTraining
